import { render, staticRenderFns } from "./LongitudinalTrackingWidget.vue?vue&type=template&id=0223853e"
import script from "./LongitudinalTrackingWidget.vue?vue&type=script&lang=js"
export * from "./LongitudinalTrackingWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports